var _rect, _title, _circle, _circle2, _circle3, _circle4, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEtherscanSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 20,
    preserveAspectRatio: "xMidYMid",
    style: {
      background: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 10,
    r: 0,
    fill: "#dce4eb",
    id: "svg_1",
    className: ""
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "10;0;0;0;0",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "2.5s",
    repeatCount: "indefinite",
    begin: "0s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "84;84;84;84;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "2.5s",
    repeatCount: "indefinite",
    begin: "0s"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.9276,
    cy: 10,
    r: 10,
    fill: "#bbcedd",
    id: "svg_2",
    className: ""
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;10;10;10;0",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "2.5s",
    repeatCount: "indefinite",
    begin: "-1.25s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "16;16;50;84;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "2.5s",
    repeatCount: "indefinite",
    begin: "-1.25s"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 10,
    r: 5.27281,
    fill: "#85a2b6",
    id: "svg_3",
    className: ""
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;10;10;10;0",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "2.5s",
    repeatCount: "indefinite",
    begin: "-0.625s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "16;16;50;84;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "2.5s",
    repeatCount: "indefinite",
    begin: "-0.625s"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 10,
    r: 4.72719,
    fill: "#fdfdfd",
    id: "svg_4",
    className: ""
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;10;10;10;0",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "2.5s",
    repeatCount: "indefinite",
    begin: "0s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "16;16;50;84;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "2.5s",
    repeatCount: "indefinite",
    begin: "0s"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.9276,
    cy: 10,
    r: 10,
    fill: "#dce4eb",
    id: "svg_5",
    className: ""
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "0;0;10;10;10",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "2.5s",
    repeatCount: "indefinite",
    begin: "0s"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "16;16;16;50;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    calcMode: "spline",
    dur: "2.5s",
    repeatCount: "indefinite",
    begin: "0s"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtherscanSpinner);
export default __webpack_public_path__ + "static/media/etherscan-spinner.b33532b0c76bb477bf8a252bd8fcd8f7.svg";
export { ForwardRef as ReactComponent };